import React from 'react';
import PropTypes from 'prop-types';
import { FooterLink } from './StyledComponents';

/**
 * React Component for Powered By Label
 * @param {Object} props - Component props
 * @param {Object} props.whiteLabelState - The white label state object containing branding info
 * @param {string} props.whiteLabelState.labelProvidedBy - The provider label text
 * @param {boolean} props.whiteLabelState.hasWhiteLabelClient - Whether white label client exists
 * @param {boolean} props.whiteLabelState.isEnclosedMode - Whether in enclosed mode
 * @returns {JSX.Element|null} Powered by component or null
 */
export default function PoweredByLabel({ whiteLabelState }) {
  const { isEnclosedMode } = whiteLabelState;

  // We are removing the ability to add a custom label. Commenting out just in
  // case we change our minds. labelProvidedBy and hasWhiteLabelClient are both
  // stored in whiteLabelState and FooterText in StyledComponents.
  // if (!!hasWhiteLabelClient && !isEnclosedMode && hasValue(labelProvidedBy)) {
  //   return <FooterText>{`Powered by ${labelProvidedBy}`}</FooterText>;
  // }

  if (!!isEnclosedMode) {
    return null;
  }

  return (
    <FooterLink id="sc-powered_by_link" href="https://www.swipeclock.com/">
      Powered by SwipeClock.
    </FooterLink>
  );
}

PoweredByLabel.propTypes = {
  whiteLabelState: PropTypes.shape({
    labelProvidedBy: PropTypes.string,
    hasWhiteLabelClient: PropTypes.bool,
    isEnclosedMode: PropTypes.bool,
  }),
};
